  <aside class="sidebar" [ngClass]="{collapsed: isCollapsed}">
    <div class="menu">
      <div class="d-flex w-100 justify-content-center align-items-start mt-4">
        <img
          [src]="'assets/instances-config/' + instanceName + '/layout/visual-identity/images/navbar-brand.png'"
          style="width: 200px"
          alt=""
        />
      </div>
      <div *ngFor="let item of menu" class="menu-items" [routerLink]="item.url">
        <!-- Items without submenu -->
        <ng-container>
          <div *ngIf="!item.subRoutes" class="menu-items-content" routerLinkActive="is-active">
            <div class="line">
              <i class="{{ getIconClass(item) }}"></i>
              <span class="text">{{ item.title }}</span>
            </div>
          </div>
        </ng-container>

        <!-- Items with submenu -->
        <ng-container>
          <div *ngIf="item.subRoutes">
            <div class="menu-items-content" class="{{ getActiveClass(item) }}" (click)="toggleSubmenu(item)">
              <div class="line">
                <i class="{{ getIconClass(item) }}"></i>
                <span class="text">{{ item.title }}</span>
              </div>
              <i class="bi bi-chevron-down" [ngClass]="{rotate: item.isOpen}"></i>
            </div>
            <div *ngIf="item.isOpen" class="submenu">
              <div
                *ngFor="let subItem of item.subRoutes"
                class="submenu-item"
                [routerLink]="subItem.url"
                routerLinkActive="is-active-sub"
                (click)="closeAllSubmenus()"
              >
                <div class="point"></div>
                {{ subItem.title }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </aside>
